import { ACCESS_ROLES, portalForAccessRole, roleCan, type AccessRole } from '@services/access';
import { PORTALS, type MenuEntry, type NavItem } from '../model/portals';

export type { NavItem } from '../model/portals';

export function navItemIsActive(item: NavItem, location: string): boolean {
  const path = location.split('?')[0];
  return path === item.path || path.startsWith(`${item.path}/`);
}

function toNavItem({ requires: _requires, ...item }: MenuEntry): NavItem {
  return item;
}

function allowed(role: AccessRole, entry: MenuEntry): boolean {
  return !entry.requires || roleCan(role, entry.requires);
}

function homeMenu(role: AccessRole): NavItem[] {
  return PORTALS[portalForAccessRole(role)].menu
    .filter((entry) => allowed(role, entry))
    .map(toNavItem);
}

const HOME_MENUS = Object.fromEntries(ACCESS_ROLES.map((role) => [role, homeMenu(role)])) as Record<
  AccessRole,
  NavItem[]
>;

export function menuByRole(role: AccessRole): NavItem[] {
  return HOME_MENUS[role];
}

export function menuPathsForRole(role: AccessRole): string[] {
  const paths: string[] = [];
  const walk = (items: NavItem[]) => {
    for (const item of items) {
      paths.push(item.path);
      if (item.children) walk(item.children);
    }
  };
  walk(menuByRole(role));
  return paths;
}
